<ui-spinner [hidden]="!!isLoaded"></ui-spinner>
<div [hidden]="!isLoaded">
    <ng-content></ng-content>
</div>

